// cali 2026-08-14 v32: cart-mutation flight recorder, ALL pages (moved from the PDP-only
// customization-app preamble). Wraps fetch AND XHR, parses JSON/urlencoded/FormData bodies,
// keeps variant:hash8 keys and a 400-char caller stack so destructive writes are attributable.
(function () {
  if (window.__caliCartRec) return;
  window.__caliCartRec = 33;
  var RE = /\/cart\/(add|update|change|clear)\.js/;
  function kslice(k) {
    var p = String(k).split(':');
    return p[0] + (p[1] ? ':' + p[1].slice(0, 8) : '');
  }
  function fromPairs(pairs) {
    var ups = [], other = [], i, k, v;
    for (i = 0; i < pairs.length; i++) {
      k = pairs[i][0]; v = pairs[i][1];
      if (k.indexOf('updates[') === 0) ups.push(kslice(k.slice(8, -1)) + '=' + v);
      else if (k === 'id' || k === 'quantity' || k === 'line') other.push(k + '=' + (k === 'id' ? kslice(v) : v));
      else if (k.indexOf('attributes') === 0) other.push('attr:' + k.slice(0, 30));
    }
    if (ups.length) return 'updates:' + ups.join(',');
    return other.length ? other.join(',') : 'form-other';
  }
  function summarize(body) {
    try {
      if (body == null) return 'empty';
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        var ps = []; body.forEach(function (v, k) { ps.push([k, String(v)]); });
        return fromPairs(ps);
      }
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var pf = [];
        try { body.forEach(function (v, k) { pf.push([k, String(v)]); }); } catch (e) { return 'formdata-opaque'; }
        return fromPairs(pf);
      }
      if (typeof body === 'string') {
        if (body.charAt(0) === '{' || body.charAt(0) === '[') {
          var j = JSON.parse(body);
          if (j.items) return 'items:' + j.items.map(function (it) {
            var pr = it.properties || {};
            return it.id + ':' + (pr._bundleType || 'x') + ':' + (pr._bid || '-');
          }).join(',');
          if (j.updates) return 'updates:' + Object.keys(j.updates).map(function (k) {
            return kslice(k) + '=' + j.updates[k];
          }).join(',');
          if (j.id !== undefined) return 'change:' + kslice(j.id) + '=' + j.quantity;
          if (j.attributes) return 'attributes:' + Object.keys(j.attributes).join(',').slice(0, 80);
          if (j.note !== undefined) return 'note';
          return 'json-other:' + Object.keys(j).join(',').slice(0, 60);
        }
        var qs = []; body.split('&').forEach(function (kv) {
          var eq = kv.indexOf('=');
          if (eq > 0) {
            try { qs.push([decodeURIComponent(kv.slice(0, eq).replace(/\+/g, ' ')), decodeURIComponent(kv.slice(eq + 1).replace(/\+/g, ' '))]); } catch (e) {}
          }
        });
        if (qs.length) return fromPairs(qs);
        return 'unparsed';
      }
      return 'unparsed-type';
    } catch (e) { return 'unparsed'; }
  }
  function record(kind, body) {
    try {
      var sum = summarize(body);
      // cali 2026-08-17: benign-noise filter - pixel attribute writes and notes were ~90%
      // of beacon volume (13k/day) with zero forensic value; don't spend invocations on them.
      if (kind === 'update' && (sum.indexOf('attributes:') === 0 || sum === 'note' || sum === 'form-other')) return;
      var stack = '';
      try {
        stack = (new Error().stack || '').split('\n').slice(2, 8).map(function (l) {
          return l.replace(/^\s+at\s+/, '').trim();
        }).join('|');
      } catch (e) {}
      navigator.sendBeacon('https://labomono.vercel.app/api/client-beacon',
        new Blob([JSON.stringify({ type: 'cart_mutation', kind: kind, sum: sum.slice(0, 300),
          stack: stack.slice(0, 400), page: location.pathname.slice(0, 60), build: 35 })],
        { type: 'text/plain' }));
    } catch (e) {}
  }
  var _fetch = window.fetch;
  window.fetch = function (u, o) {
    try {
      var s = String((u && u.url) || u || '');
      var m = RE.exec(s);
      if (m) record(m[1], (u && u.url) ? null : (o && o.body));
    } catch (e) {}
    return _fetch.apply(this, arguments);
  };
  try {
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      try { var m = RE.exec(String(url || '')); this.__caliCart = m ? m[1] : null; } catch (e) {}
      return _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      try { if (this.__caliCart) record(this.__caliCart, body); } catch (e) {}
      return _send.apply(this, arguments);
    };
  } catch (e) {}
})();

// Core cart validation helpers
// cali 2026-09-09 (v34): the last cart attributes seen by the validator, so the checkout
// click handler below can decide synchronously and never touch a normal cart.
window.__caliCartAttrs = window.__caliCartAttrs || null;
window.__caliRefreshCartCache = function () {
  return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
    window.__caliCartAttrs = (c && c.attributes) || {}; window.__caliCartItems = (c && c.items) || []; return c;
  }).catch(function () { return null; });
};
document.addEventListener('cart:build', function () { setTimeout(window.__caliRefreshCartCache, 300); });
document.addEventListener('cart:updated', function () { setTimeout(window.__caliRefreshCartCache, 300); });
function getCartValidationResults(cartItems) {
    if (!Array.isArray(cartItems)) {
      return {
        isValid: false,
        error: 'Cart items must be an array',
        orphanedChildren: [],
        validItems: []
      };
    }
  
    const itemsByBid = {};
    const orphanedChildren = [];
    const validItems = [];
  
    cartItems.forEach((item, index) => {
      const bid = item && item.properties ? item.properties._bid : undefined;
      if (bid) {
        if (!itemsByBid[bid]) itemsByBid[bid] = [];
        itemsByBid[bid].push({ ...item, __originalIndex: index });
      }
    });
    
    // Check if cart has any master products at all
    const hasAnyMaster = cartItems.some((item) => 
      item && item.properties && item.properties._bundleType === 'master'
    );
    
    // If cart has no master products, mark all child items as orphaned
    if (!hasAnyMaster) {
      cartItems.forEach((item, index) => {
        if (item && item.properties && item.properties._bundleType === 'child') {
          orphanedChildren.push({ ...item, __originalIndex: index });
        }
      });
    } else {
      // If master products exist, use existing bundle group validation logic
      Object.keys(itemsByBid).forEach((bid) => {
        const groupItems = itemsByBid[bid];
        const hasMaster = groupItems.some((it) => it && it.properties && it.properties._bundleType === 'master');
        if (hasMaster) {
          validItems.push(...groupItems);
        } else {
          orphanedChildren.push(...groupItems);
        }
      });
    }
   
    cartItems.forEach((item, index) => {
      const hasBid = item && item.properties ? item.properties._bid : undefined;
      if (!hasBid) validItems.push({ ...item, __originalIndex: index });
    });
  
    return {
      isValid: orphanedChildren.length === 0,
      orphanedChildren: orphanedChildren.map(({ __originalIndex, ...rest }) => rest),
      validItems: validItems
        .sort((a, b) => (a.__originalIndex || 0) - (b.__originalIndex || 0))
        .map(({ __originalIndex, ...rest }) => rest),
      totalItems: cartItems.length,
      validItemsCount: validItems.length,
      orphanedCount: orphanedChildren.length
    };
  }
  
  function removeOrphanedChildProducts(cartItems) {
    const results = getCartValidationResults(cartItems);
    return results.validItems;
  }
  
  // Utility to sync child quantities with master quantity for same bundle ID
  function syncChildQuantitiesWithMaster(cartItems) {
    if (!Array.isArray(cartItems)) return {};
    
    const itemsByBid = {};
    const quantityUpdates = {};
    
    // Group items by bundle ID
    cartItems.forEach((item) => {
      const bid = item && item.properties ? item.properties._bid : undefined;
      if (bid) {
        if (!itemsByBid[bid]) itemsByBid[bid] = [];
        itemsByBid[bid].push(item);
      }
    });
    
    // For each bundle group, sync child quantities with master quantity
    Object.keys(itemsByBid).forEach((bid) => {
      const groupItems = itemsByBid[bid];
      const masterItem = groupItems.find((it) => it && it.properties && it.properties._bundleType === 'master');
      
      if (masterItem && masterItem.quantity) {
        const masterQuantity = masterItem.quantity;
        const childItems = groupItems.filter((it) => it && it.properties && it.properties._bundleType === 'child');
        
        // Update child items to match master quantity
        childItems.forEach((childItem) => {
          if (childItem.key && childItem.quantity !== masterQuantity) {
            quantityUpdates[childItem.key] = masterQuantity;
          }
        });
      }
    });
    
    return quantityUpdates;
  }
  
  // Utility to remove specific line item keys from cart
  function cleanCart(orphanedItems) {
    if (!orphanedItems || orphanedItems.length === 0) return Promise.resolve();
    const updates = {};
    orphanedItems.forEach((item) => {
      if (item && item.key) updates[item.key] = 0;
    });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    }).then((r) => r.json());
  }

  // cali 2026-08-14 v2: deletion needs TWO independent snapshots to agree. The sweeper's
  // one-read design was the top root-cause suspect for the #55272 class: a stale or
  // mid-mutation /cart.js read makes the master look absent and the sweep deletes live
  // children. Now the orphans from the first read are re-checked against a fresh no-store
  // read at write time; only children orphaned in BOTH reads are removed. This also makes
  // a stale sweep harmless after healChildlessMasters (the fresh read sees the healed cart).
  function cleanCartConfirmed(firstOrphans) {
    if (!firstOrphans || firstOrphans.length === 0) return Promise.resolve();
    return fetch('/cart.js', { cache: 'no-store' })
      .then((r) => r.json())
      .then((fresh) => {
        const res2 = getCartValidationResults(fresh.items || []);
        const stillOrphaned = {};
        (res2.orphanedChildren || []).forEach((it) => { if (it && it.key) stillOrphaned[it.key] = true; });
        const confirmed = firstOrphans.filter((it) => it && it.key && stillOrphaned[it.key]);
        if (confirmed.length === 0) return;
        return cleanCart(confirmed);
      });
  }
  
  // cali 2026-08-14 (order #55272): EXIT guard - a master whose _bid group has lost its
// children is rebuilt from the master's own question_* properties (each carries the
// child's shopify_variant_id). Whatever deleted the children, the cart heals before
// checkout. Every repair (and failure) beacons `cart_repair`.
function healChildlessMasters(cartItems) {
  try {
    const byBid = {};
    cartItems.forEach((it) => {
      const bid = it && it.properties ? it.properties._bid : undefined;
      if (!bid) return;
      if (!byBid[bid]) byBid[bid] = [];
      byBid[bid].push(it);
    });
    const toAdd = [];
    Object.keys(byBid).forEach((bid) => {
      const group = byBid[bid];
      const master = group.find((it) => it.properties && it.properties._bundleType === 'master');
      if (!master) return;
      const childVariantIds = group
        .filter((it) => it.properties && it.properties._bundleType === 'child')
        .map((it) => Number(it.variant_id || it.id));
      const wanted = [];
      Object.keys(master.properties || {}).forEach((k) => {
        if (k.indexOf('question_') !== 0) return;
        let v = master.properties[k];
        if (typeof v === 'string') { try { v = JSON.parse(v); } catch (e) { return; } }
        const vid = v && Number(v.shopify_variant_id);
        if (vid && wanted.indexOf(vid) === -1) wanted.push(vid);
      });
      wanted.forEach((vid) => {
        if (childVariantIds.indexOf(vid) === -1) {
          toAdd.push({ id: vid, quantity: master.quantity || 1,
            properties: { _bid: String(bid), _bundleType: 'child' } });
        }
      });
    });
    if (!toAdd.length) return Promise.resolve(false);
    try {
      navigator.sendBeacon('https://labomono.vercel.app/api/client-beacon',
        new Blob([JSON.stringify({ type: 'cart_repair', page: location.pathname.slice(0, 60),
          adding: toAdd.map((x) => x.id + ':' + x.properties._bid).join(',').slice(0, 150) })],
        { type: 'text/plain' }));
    } catch (e) {}
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: toAdd })
    }).then((r) => {
      if (!r.ok) {
        try {
          navigator.sendBeacon('https://labomono.vercel.app/api/client-beacon',
            new Blob([JSON.stringify({ type: 'cart_repair', page: location.pathname.slice(0, 60),
              failed: true, status: r.status })], { type: 'text/plain' }));
        } catch (e) {}
      }
      try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
      return true;
    }).catch(() => false);
  } catch (e) { return Promise.resolve(false); }
}

// cali 2026-08-14 v2: single-flight - overlapping passes (load + burst of cart:updated
  // events + multi-tab) queue instead of racing each other's snapshots.
  var __cvInflight = false;
  var __cvQueued = false;
  function validateCartAndClean() {
    if (__cvInflight) { __cvQueued = true; return Promise.resolve(); }
    __cvInflight = true;
    var __cvDone = function () {
      __cvInflight = false;
      if (__cvQueued) { __cvQueued = false; setTimeout(validateCartAndClean, 50); }
    };
    return __validatePass().then(__cvDone, __cvDone);
  }

  function __validatePass() {
    return fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const cartItems = cart.items || [];
        try { window.__caliCartAttrs = cart.attributes || {}; window.__caliCartItems = cartItems; } catch (_ca) {}
        // exit-guard first: childless masters get their children rebuilt; a heal triggers
        // cart:build -> cart:updated -> re-validation on the healed cart
        const __healP = healChildlessMasters(cartItems);
        if (__healP && typeof __healP.then === 'function') {
          return __healP.then((didHeal) => { if (didHeal) { setTimeout(validateCartAndClean, 1200); return; } return __afterHeal(cartItems); });
        }
        return __afterHeal(cartItems);
      })
      .catch((err) => console.warn('Cart validation error:', err));
  }

  function __afterHeal(cartItems) {
    return Promise.resolve()
      .then(() => {
        
        // First, sync child quantities with master quantities for same bundle ID
        const quantityUpdates = syncChildQuantitiesWithMaster(cartItems);
        if (Object.keys(quantityUpdates).length > 0) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: quantityUpdates })
          })
          .then((r) => r.json())
          .then(() => {
            // drawer re-render so its inputs match the synced server state (else the native
            // positional updates[] checkout POST reverts child quantities from stale DOM)
            try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (_) {}
            // After syncing quantities, validate for orphaned children
            return fetch('/cart.js')
              .then((r) => r.json())
              .then((updatedCart) => {
                const results = getCartValidationResults(updatedCart.items || []);
                if (!results.isValid && results.orphanedCount > 0) {
                  return cleanCartConfirmed(results.orphanedChildren).then(() => {
                    // Seamless refresh: re-render the cart drawer in place instead of a
                    // full page reload (which closes the drawer). 'cart:build' is the
                    // Motion theme's own drawer-rebuild hook (re-fetches cart markup).
                    try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (_) {}
                  });
                }
              });
          });
        }
        
        // If no quantity updates needed, just check for orphaned children
        const results = getCartValidationResults(cartItems);
        if (!results.isValid && results.orphanedCount > 0) {
          return cleanCartConfirmed(results.orphanedChildren).then(() => {
            // Seamless refresh: re-render the cart drawer in place instead of a full page
            // reload (which closes the drawer). 'cart:build' is the Motion theme's own
            // drawer-rebuild hook (re-fetches cart markup).
            try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (_) {}
          });
        }
      })
      .catch((err) => console.warn('Cart validation error:', err));
  }
  
  // Expose globals immediately (no DOMContentLoaded race)
  if (typeof window !== 'undefined') {
    window.getCartValidationResults = getCartValidationResults;
    window.removeOrphanedChildProducts = removeOrphanedChildProducts;
    window.validateCartManually = validateCartAndClean;
    window.syncChildQuantitiesWithMaster = syncChildQuantitiesWithMaster;
  }
  
  // Auto-run on load and cart updates
  // ---- cali 2026-09-09 (v34): INSTAGRAM-BORN CART REROUTE ------------------------------
  // See patch-ig-reroute-v34.py for the why. Only carts that carry Instagram's own
  // attributes AND a built bag are touched; every other checkout click passes through
  // untouched (no preventDefault, no extra request).
  var __caliSfToken = '9b0e158d4e32c26e483313dce07b8dd5';
  function __caliBornInInstagram() {
    var a = window.__caliCartAttrs || {};
    return a['Channel'] === 'Instagram' || !!a['cart-id'];
  }
  function __caliHasBuiltBag() {
    return (window.__caliCartItems || []).some(function (it) {
      return it && it.properties && it.properties._bundleType === 'master';
    });
  }
  function __caliBeacon(type, extra) {
    try {
      var p = { type: type, page: location.pathname.slice(0, 60), build: 35,
        country: (window.Shopify && window.Shopify.country) || '' };
      for (var k in extra) p[k] = extra[k];
      navigator.sendBeacon('https://labomono.vercel.app/api/client-beacon',
        new Blob([JSON.stringify(p)], { type: 'text/plain' }));
    } catch (_e) {}
  }
  function __caliRerouteToCleanCheckout() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      var lines = (cart.items || []).map(function (it) {
        var attrs = [];
        var props = it.properties || {};
        Object.keys(props).forEach(function (k) {
          var v = props[k];
          if (v === null || v === undefined) return;
          attrs.push({ key: k, value: typeof v === 'string' ? v : JSON.stringify(v) });
        });
        return { merchandiseId: 'gid://shopify/ProductVariant/' + it.variant_id, quantity: it.quantity, attributes: attrs };
      });
      var input = { lines: lines };
      // A Storefront cart is independent of the Online Store cart. Carry the
      // native code state across this Instagram checkout repair, including a
      // gift code and any combinable shipping code.
      var discountCodes = (cart.discount_codes || []).map(function (entry) {
        return typeof entry === 'string' ? entry : entry && entry.code;
      }).filter(Boolean);
      (cart.cart_level_discount_applications || []).forEach(function (application) {
        if (application.type === 'discount_code' && application.title && discountCodes.indexOf(application.title) === -1) discountCodes.push(application.title);
      });
      (cart.items || []).forEach(function (item) {
        (item.line_level_discount_allocations || []).forEach(function (allocation) {
          var application = allocation.discount_application || {};
          var code = application.code || application.title;
          if (application.type === 'discount_code' && code && discountCodes.indexOf(code) === -1) discountCodes.push(code);
        });
      });
      if (discountCodes.length) input.discountCodes = discountCodes;
      var cc = window.Shopify && window.Shopify.country;
      if (cc) input.buyerIdentity = { countryCode: cc };
      if (cart.note) input.note = cart.note;
      return fetch('https://labomono.com/api/2026-07/graphql.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': __caliSfToken },
        body: JSON.stringify({
          query: 'mutation($input:CartInput!){ cartCreate(input:$input){ cart{ id checkoutUrl } userErrors{ field message } } }',
          variables: { input: input }
        })
      }).then(function (r) { return r.json(); }).then(function (j) {
        var res = j && j.data && j.data.cartCreate;
        var url = res && res.cart && res.cart.checkoutUrl;
        var err = (res && res.userErrors && res.userErrors[0] && res.userErrors[0].message) ||
                  (j && j.errors && j.errors[0] && j.errors[0].message) || '';
        __caliBeacon('ig_cart_reroute', { ok: !!url, lines: lines.length, err: String(err).slice(0, 80) });
        if (!url) throw new Error(err || 'no checkoutUrl');
        window.location.href = url;
        return true;
      });
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('button[name="checkout"], .cart__checkout, a[href^="/checkout"]');
    if (!t) return;
    if (!__caliBornInInstagram()) return; // normal cart: untouched, not even a request
    if (window.__caliRerouting) { e.preventDefault(); return; }
    window.__caliRerouting = true;
    e.preventDefault(); e.stopPropagation();
    try { t.setAttribute('disabled', 'disabled'); } catch (_d) {}
    // v35: the cached items can be stale (the builder's add does not fire cart:updated), so
    // the decision is made on a FRESH read. No built bag -> plain checkout, nothing lost.
    window.__caliRefreshCartCache().then(function () {
      if (!__caliHasBuiltBag()) { window.__caliRerouting = false; window.location.href = '/checkout'; return true; }
      return __caliRerouteToCleanCheckout();
    }).catch(function (err) {
      // Never strand the customer: fall back to the normal checkout, where the Guard's
      // Instagram message explains what to do.
      __caliBeacon('ig_cart_reroute', { ok: false, fallback: true, err: String(err && err.message || err).slice(0, 80) });
      window.__caliRerouting = false;
      try { t.removeAttribute('disabled'); } catch (_d2) {}
      window.location.href = '/checkout';
    });
  }, true);
  // ------------------------------------------------------------------------------------------

  (function ensureInit() {
    function run() {
      validateCartAndClean();
      document.addEventListener('cart:updated', function() {
        setTimeout(validateCartAndClean, 100);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();
  
  